import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/repairtype/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/repairtype/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/repairtype/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/repairtype/submit', params, options);

export const update = (params, options) => request.post('/api/repairtype/submit', params, options);

export const forbidden = (params, options) =>
  request.post('/api/repairtype/forbidden', qs.stringify(params), options);

export const start = (params, options) =>
  request.post('/api/repairtype/start', qs.stringify(params), options);

export const selectType = (params, options) =>
  request.get('/api/repairtype/selectType', Object.assign({}, options, { params }));

export const selectAllType = (params, options) =>
  request.get('/api/repairtype/selectAllType', Object.assign({}, options, { params }));
